export default {
  configurations_pending: false,
  configurations: []
}
